import { usePageTitle } from "./hooks/usePageTitle";

function TermsOfUse() {
  usePageTitle('Terms of Use')
  return (
    <div
      id="ts-privacy-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-privacy-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Terms of Use
        </div>
        <div className="w-full text-normal flex flex-col items-start justify-start p-2 space-y-4">
          <span>
            Please also read our{' '}
            <a className="text-light-text-link" href="/privacy/privacy-policy">
              Privacy Policy
            </a>{' '}
            for this website.
          </span>
          <span>
            <strong>AGREEMENT BETWEEN USER AND TERRASCIENCES LTD.</strong>
            <br />
            The TerraSciences Ltd. web site is comprised of various web pages
            operated by TerraSciences Ltd.. The TerraSciences Ltd. web site is
            offered to you conditioned on your acceptance without modification
            of the terms, conditions, and notices contained herein. Your use of
            the TerraSciences Ltd. web site constitutes your agreement to all
            such terms, conditions, and notices.
          </span>
          <span>
            <strong>MODIFICATION OF THESE TERMS OF USE </strong>
            <br /> TerraSciences Ltd. reserves the right to change the terms,
            conditions, and notices under which the TerraSciences Ltd. web site
            is offered, including but not limited to the charges associated with
            the use of the TerraSciences Ltd. web site.
          </span>
          <span>
            <strong>LINKS TO THIRD PARTY SITES</strong>
            <br />
            The TerraSciences Ltd. web site may contain links to other web sites
            ("Linked Sites"). The Linked Sites are not under the control of
            TerraSciences Ltd. and TerraSciences Ltd. is not responsible for the
            contents of any Linked Site, including without limitation any link
            contained in a Linked Site, or any changes or updates to a Linked
            Site. TerraSciences Ltd. is not responsible for webcasting or any
            other form of transmission received from any Linked Site.
            TerraSciences Ltd. is providing these links to you only as a
            convenience, and the inclusion of any link does not imply
            endorsement by TerraSciences Ltd. of the site or any association
            with its operators.
          </span>
          <span>
            <strong>NO UNLAWFUL OR PROHIBITED USE</strong>
            <br /> As a condition of your use of the TerraSciences Ltd. web
            site, you warrant to TerraSciences Ltd. that you will not use the
            TerraSciences Ltd. web site for any purpose that is unlawful or
            prohibited by these terms, conditions, and notices. You may not use
            the TerraSciences Ltd. web site in any manner which could damage,
            disable, overburden, or impair the TerraSciences Ltd. web site or
            interfere with any other party's use and enjoyment of the
            TerraSciences Ltd. web site. You may not obtain or attempt to obtain
            any materials or information through any means not intentionally
            made available or provided for through the TerraSciences Ltd. web
            sites.
          </span>
          <span>
            <strong>USE OF COMMUNICATION SERVICES</strong>
            <br /> The TerraSciences Ltd. web site may contain bulletin board
            services, chat areas, news groups, forums, communities, personal web
            pages, calendars, and/or other message or communication facilities
            designed to enable you to communicate with the public at large or
            with a group (collectively, "Communication Services"), you agree to
            use the Communication Services only to post, send and receive
            messages and material that are proper and related to the particular
            Communication Service. By way of example, and not as a limitation,
            you agree that when using a Communication Service, you will not:
            <br />
            <span>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Defame, abuse, harass, stalk, threaten or otherwise violate
                  the legal rights (such as rights of privacy and publicity) of
                  others.
                </li>
                <li>
                  Publish, post, upload, distribute or disseminate any
                  inappropriate, profane, defamatory, infringing, obscene,
                  indecent or unlawful topic, name, material or information.
                </li>
                <li>
                  Upload files that contain software or other material protected
                  by intellectual property laws (or by rights of privacy of
                  publicity) unless you own or control the rights thereto or
                  have received all necessary consents.
                </li>
                <li>
                  Upload files that contain viruses, corrupted files, or any
                  other similar software or programs that may damage the
                  operation of another's computer.
                </li>
                <li>
                  Advertise or offer to sell or buy any goods or services for
                  any business purpose, unless such Communication Service
                  specifically allows such messages.
                </li>{' '}
                <li>
                  Conduct or forward surveys, contests, pyramid schemes or chain
                  letters.
                </li>
                <li>
                  Download any file posted by another user of a Communication
                  Service that you know, or reasonably should know, cannot be
                  legally distributed in such manner.
                </li>
                <li>
                  Falsify or delete any author attributions, legal or other
                  proper notices or proprietary designations or labels of the
                  origin or source of software or other material contained in a
                  file that is uploaded.
                </li>
                <li>
                  Restrict or inhibit any other user from using and enjoying the
                  Communication Services. Violate any code of conduct or other
                  guidelines which may be applicable for any particular
                  Communication Service.
                </li>
                <li>
                  Harvest or otherwise collect information about others,
                  including e-mail addresses, without their consent.
                </li>
                <li>Violate any applicable laws or regulations.</li>
              </ul>
            </span>
            <br />
            TerraSciences Ltd. has no obligation to monitor the Communication
            Services. However, TerraSciences Ltd. reserves the right to review
            materials posted to a Communication Service and to remove any
            materials in its sole discretion. TerraSciences Ltd. reserves the
            right to terminate your access to any or all of the Communication
            Services at any time without notice for any reason whatsoever.
            <br />
            <br />
            TerraSciences Ltd. reserves the right at all times to disclose any
            information as necessary to satisfy any applicable law, regulation,
            legal process or governmental request, or to edit, refuse to post or
            to remove any information or materials, in whole or in part, in
            TerraSciences Ltd.'s sole discretion.
            <br />
            <br />
            Always use caution when giving out any personally identifying
            information about yourself or family member in any Communication
            Service. TerraSciences Ltd. does not control or endorse the content,
            messages or information found in any Communication Service and,
            therefore, TerraSciences Ltd. specifically disclaims any liability
            with regard to the Communication Services and any actions resulting
            from your participation in any Communication Service. Managers and
            hosts are not authorized TerraSciences Ltd. spokespersons, and their
            views do not necessarily reflect those of TerraSciences Ltd..
            <br />
            <br />
            Materials uploaded to a Communication Service may be subject to
            posted limitations on usage, reproduction and/or dissemination. You
            are responsible for adhering to such limitations if you download the
            materials.
          </span>
          <span>
            <strong>
              MATERIALS PROVIDED TO TERRASCIENCES Inc. OR POSTED AT ANY
              TERRASCIENCES Inc. WEB SITE
            </strong>
            <br /> TerraSciences Ltd. does not claim ownership of the materials
            you provide to TerraSciences Ltd. (including feedback and
            suggestions) or post, upload, input or submit to any TerraSciences
            Ltd. web site or its associated services (collectively
            "Submissions"). However, by posting, uploading, inputting, providing
            or submitting your Submission you are granting TerraSciences Ltd.,
            its affiliated companies and necessary sublicensees permission to
            use your Submission in connection with the operation of their
            Internet businesses including, without limitation, the rights to:
            copy, distribute, transmit, publicly display, publicly perform,
            reproduce, edit, translate and reformat your Submission; and to
            publish your name in connection with your Submission.
            <br />
            <br />
            No compensation will be paid with respect to the use of your
            Submission, as provided herein. TerraSciences Ltd. is under no
            obligation to post or use any Submission you may provide and may
            remove any Submission at any time in TerraSciences Ltd.'s sole
            discretion.
            <br />
            <br />
            By posting, uploading, inputting, providing or submitting your
            Submission you warrant and represent that you own or otherwise
            control all of the rights to your Submission as described in this
            section including, without limitation, all the rights necessary for
            you to provide, post, upload, input or submit the Submissions.{' '}
          </span>
          <span>
            <strong>LIABILITY DISCLAIMER</strong>
            <br /> The information, software, products, and services included in
            or available through the TerraSciences Ltd. web site may include
            inaccuracies or typographical errors. Changes are periodically added
            to the information herein. TerraSciences Ltd. and/or its suppliers
            may make improvements and/or changes in the TerraSciences Ltd. web
            site at any time. Advice received via the TerraSciences Ltd. web
            site should not be relied upon for personal, medical, legal or
            financial decisions and you should consult an appropriate
            professional for specific advice tailored to your situation.
            <br />
            <br />
            TerraSciences Ltd. and/or its suppliers make no representations
            about the suitability, reliability, availability, timeliness, and
            accuracy of the information, software, products, services and
            related graphics contained on the TerraSciences Ltd. web site for
            any purpose. To the maximum extent permitted by applicable law, all
            such information, software, products, services and related graphics
            are provided "as is" without warranty or condition of any kind.
            TerraSciences Ltd. and/or its suppliers hereby disclaim all
            warranties and conditions with regard to this information, software,
            products, services and related graphics, including all implied
            warranties or conditions of merchantability, fitness for a
            particular purpose, title and non-infringement.
            <br />
            <br />
            To the maximum extent permitted by applicable law, in no event shall
            TerraSciences Ltd. and/or its suppliers be liable for any direct,
            indirect, punitive, incidental, special, consequential damages or
            any damages whatsoever including, without limitation, damages for
            loss of use, data or profits, arising out of or in any way connected
            with the use or performance of the TerraSciences Ltd. web site, with
            the delay or inability to use the TerraSciences Ltd. web site or
            related services, the provision of or failure to provide services,
            or for any information, software, products, services and related
            graphics obtained through the TerraSciences Ltd. web site, or
            otherwise arising out of the use of the TerraSciences Ltd. web site,
            whether based on contract, negligence, strict liability or
            otherwise, even if TerraSciences Ltd. or any of its suppliers has
            been advised of the possibility of damages. Because some
            states/jurisdictions do not allow the exclusion or limitation of
            liability for consequential or incidental damages, the above
            limitation may not apply to you. If you are dissatisfied with any
            portion of the TerraSciences Ltd. web site, or with any of these
            terms of use, your sole and exclusive remedy is to discontinue using
            the TerraSciences Ltd. web site.
          </span>
          <span>
            <strong>TERMINATION/ACCESS RESTRICTION</strong>
            <br />
            TerraSciences Ltd. reserves the right, in its sole discretion, to
            terminate your access to the TerraSciences Ltd. web site and the
            related services or any portion thereof at any time, without notice.
            To the maximum extent permitted by law, this agreement is governed
            by the laws of England, United Kingdom in all disputes arising out
            of or relating to the use of the TerraSciences Ltd. web site. Use of
            the TerraSciences Ltd. web site is unauthorized in any jurisdiction
            that does not give effect to all provisions of these terms and
            conditions, including without limitation this paragraph. You agree
            that no joint venture, partnership, employment, or agency
            relationship exists between you and TerraSciences Ltd. as a result
            of this agreement or use of the TerraSciences Ltd. web site.
            TerraSciences Ltd.'s performance of this agreement is subject to
            existing laws and legal process, and nothing contained in this
            agreement is in derogation of TerraSciences Ltd.'s right to comply
            with governmental, court and law enforcement requests or
            requirements relating to your use of the TerraSciences Ltd. web site
            or information provided to or gathered by TerraSciences Ltd. with
            respect to such use. If any part of this agreement is determined to
            be invalid or unenforceable pursuant to applicable law including,
            but not limited to, the warranty disclaimers and liability
            limitations set forth above, then the invalid or unenforceable
            provision will be deemed superseded by a valid, enforceable
            provision that most closely matches the intent of the original
            provision and the remainder of the agreement shall continue in
            effect. Unless otherwise specified herein, this agreement
            constitutes the entire agreement between the user and TerraSciences
            Ltd. with respect to the TerraSciences Ltd. web site and it
            supersedes all prior or contemporaneous communications and
            proposals, whether electronic, oral or written, between the user and
            TerraSciences Ltd. with respect to the TerraSciences Ltd. web site.
            A printed version of this agreement and of any notice given in
            electronic form shall be admissible in judicial or administrative
            proceedings based upon or relating to this agreement to the same
            extent and subject to the same conditions as other business
            documents and records originally generated and maintained in printed
            form. It is the express wish to the parties that this agreement and
            all related documents be drawn up in English.
          </span>{' '}
          <span>
            <strong>COPYRIGHT AND TRADEMARK NOTICES</strong>
            <br /> All contents of the TerraSciences Ltd. web site are:
            Copyright by TerraSciences Ltd. and/or its suppliers. All rights
            reserved.  
          </span>
          <span>
            <strong>TRADEMARKS</strong>
            <br /> The names of actual companies and products mentioned herein
            may be the trademarks of their respective owners. The example
            companies, organizations, products, people and events depicted
            herein are fictitious. No association with any real company,
            organization, product, person, or event is intended or should be
            inferred. Any rights not expressly granted herein are reserved.
          </span>{' '}
          <span>
            <strong>
              NOTICES AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT
            </strong>
            <br />
            TerraSciences Ltd respects the intellectual property rights of
            others and expects users of its services to do the same.
            TerraSciences Ltd will respond appropriately to notices of alleged
            copyright infringement in accordance with applicable copyright law
            and intermediary liability regulations in the United Kingdom.
            <br /> <br />
            Copyright owners, or their authorised agents, who believe that
            material made available through the TerraSciences Ltd services
            infringes their copyright may submit a written notification as set
            out below.
          </span>{' '}
          <span>
            <strong>Where to Send Notifications</strong>
            <br /> All notices of alleged copyright infringement should be sent
            in writing to:
            <br />
            TerraSciences Ltd <br />
            Winceby House
            <br /> Winceby
            <br /> Horncastle
            <br /> Lincolnshire
            <br />
            LN9 6PB United Kingdom
          </span>
          <span>
            <strong>Required Contents of a Notification</strong>
            <br />
            To be effective, a notification must include the following
            information: <br />
            <ul className="list-disc list-inside space-y-2">
              <li>
                A physical or electronic signature of a person authorised to act
                on behalf of the owner of the exclusive right that is alleged to
                be infringed;
              </li>{' '}
              <li>
                Identification of the copyrighted work claimed to have been
                infringed, or, where multiple copyrighted works at a single
                location are covered by a single notification, a representative
                list of such works;{' '}
              </li>
              <li>
                Identification of the material that is claimed to be infringing,
                or to be the subject of infringing activity, together with
                information reasonably sufficient to permit TerraSciences Ltd to
                locate the material;
              </li>{' '}
              <li>
                Information reasonably sufficient to permit TerraSciences Ltd to
                contact the complaining party, including a postal address,
                telephone number, and, where available, an email address;{' '}
              </li>{' '}
              <li>
                A statement that the complaining party has a good-faith belief
                that the use of the material in the manner complained of is not
                authorised by the copyright owner, its agent, or the law;
                and{' '}
              </li>{' '}
              <li>
                A statement that the information in the notification is accurate
                and that the complaining party is authorised to act on behalf of
                the owner of the exclusive right that is allegedly infringed.
              </li>
            </ul>
          </span>
          <span>
            <strong>Response to Notifications</strong>
            <br /> Upon receipt of a valid notification, TerraSciences Ltd will
            promptly investigate the matter. Where appropriate, TerraSciences
            Ltd may remove or disable access to the material that is the subject
            of the complaint. TerraSciences Ltd reserves the right to request
            additional information where necessary to assess a notification and
            to take such further action as may be required by applicable law.
          </span>
          <span>
            <strong>Governing Law and Jurisdiction</strong>
            <br /> This policy, and any dispute or claim arising out of or in
            connection with it (including non-contractual disputes or claims),
            shall be governed by and construed in accordance with the laws of
            England and Wales. The courts of England and Wales shall have
            exclusive jurisdiction to settle any dispute or claim arising out of
            or in connection with this policy.
          </span>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
